import {createContext, useContext, useEffect, useState} from 'react';
import {useServer} from "./ServerContext";


const HashContext = createContext(null);

export function HashProvider({children}) {

    const {serverAPI} = useServer();

    //
    // Functions to hash a string on 40 bits --> 7 characters
    //

    // --- 1. Hash FNV-1a 32 bits ---
    function fnv1a32(str) {
        let h = 0x811c9dc5;
        for (let i = 0; i < str.length; i++) {
            h ^= str.charCodeAt(i);
            h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
        }
        return h >>> 0;
    }

    // --- 2. Créer un pseudo-hash 40 bits à partir de deux hachages 32 bits ---
    function hash40bits(str) {
        // deux tours différents pour "étendre" à 40 bits
        const h1 = fnv1a32(str);
        const h2 = fnv1a32(str + '#'); // petit sel
        // on prend 32 bits + 8 bits du second pour 40 bits
        const high = h1;                     // 32 bits
        const low8 = (h2 & 0xFF);            // 8 bits
        // mettre dans un tableau de 5 octets
        return [
            high & 0xFF,
            (high >>> 8) & 0xFF,
            (high >>> 16) & 0xFF,
            (high >>> 24) & 0xFF,
            low8
        ];
    }

    // --- 3. Encoder 5 octets en base64url 7 caractères ---
    function bytes5_to_b64url(bytes) {
        const bin = String.fromCharCode(...bytes);
        return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    // --- 4. Fonction finale : hash 7 caractères ---
    function hash(str) {
        const bytes = hash40bits(str);
        return bytes5_to_b64url(bytes); // 7 caractères base64url
    }

    //
    // Convert local and server files associated to the username to a hashed version
    // We do it locally if not already done and then we save the whole thing on the server
    //
    async function convertCurrentUsernameIntoHash() {
        if (isHash()) return

        // Hashing local storage
        let objLocal = {}
        for (const key of Object.keys(localStorage)) {
            if (key.includes("Stats")) {
                let value = JSON.parse(localStorage.getItem(key));
                let obj = {}
                for (const [key1, value1] of Object.entries(value)) {
                    const h = hash(key1)
                    obj[h] = value1;
                }
                objLocal[key] = obj
                localStorage.setItem(key, JSON.stringify(obj))
            }
        }

        // Copy to the server
        const username = localStorage.getItem("currentUsername")
        objLocal['hash'] = 1
        await serverAPI("save", username, objLocal)

        localStorage.setItem("hash", "1")
    }

    function isHash() {
        return localStorage.getItem("hash") !== null
    }

    //
    // Defining the context
    //
    return (
        <HashContext.Provider value={{
            convertCurrentUsernameIntoHash,
            isHash,
            hash
        }}>
            {children}
        </HashContext.Provider>
    );
}

export function useHash() {
    return useContext(HashContext);
}





